import { ActionType, getType } from 'typesafe-actions';

import * as buffer from '../../actionCreators/buffer';

const initialState = null;

export default function (
  state: GPSCoordinates | null = initialState,
  action: ActionType<typeof buffer>,
): GPSCoordinates | null {
  switch (action.type) {
    case getType(buffer.clearBuffer): {
      return initialState;
    }
    case getType(buffer.setBufferDeliveryCoordinates): {
      const { value } = action.payload;
      return value || initialState;
    }
    default:
      return state;
  }
}
